import { Injectable } from "@angular/core";

/**
 * This class will be remove after implementing LocalSrorage in Angular 6.
 * It is used to create a global variable to control OnBoarding page loading.
 */
@Injectable()
export class Globals {
  // Used in onBoardingGuardService to check if OnBoarding guard is active.
  isOnBoardingActive: boolean = false;

  // Define the type of onboarding.
  // we have three type of onboarding that define when it must have shown.
  onBoardingType: number;

  // Used for controlling the repeatation of onboarding.
  onBoardingRepeatation = 0;

  // Used in LocationGuardService to check if Location guard is active.
  isCustomerLocationActive: boolean = true;

  // Define an array of paths that before routing to them we must redirect to location.
  locationPath: string[] = ["/reservation"];

  // test login User status
  isLogin = false;
}
